import { PlusGray300Icon, PlusPrimaryIcon, TrashCanErrorIcon } from '@assets/iconComponents';
import { check_circle_primary } from '@assets/icons';
import { AdminMenuTop, AdminNavigation, ForbiddenElement, GuideModal, Select, Text, TextInput } from '@components';
import { AdminModalType, ContactCountryCodeEnum, styleConstant, UserRoleEnum } from '@constant';
import { useAdminUserEdit } from '@hooks';
import { Button, MenuItem } from '@mui/material';
import { colorSet } from '@theme';

const UserEditPage = () => {
  const {
    loginUserRole,

    formData,
    passwordConfirm,
    response,
    canAccessEdit,

    handleInputChange,
    handlePasswordConfirmChange,
    handleContactChange,
    handleIpChange,
    handleAddIp,
    handleRemoveIp,
    isAddIpButtonEnabled,
    getRoleOptions,

    errors,
    scrollContainerRef,
    nameRef,
    contactRef,
    ipRefs,
    passwordRef,
    passwordConfirmRef,

    handleSubmit,

    handleCancel,
    handleDeleteButtonClick,
    isPatchUserPending,
    isDeleteUserPending,
    modalType,
    isModalVisible,
    handleModalConfirmClick,
    handleModalClose
  } = useAdminUserEdit();

  const createModalTitle = () => {
    if (modalType === AdminModalType.USER_EDIT_CANCEL) {
      return '회원정보변경을 취소하시겠습니까?';
    } else if (modalType === AdminModalType.USER_UPSERT_SUCCESS) {
      return '저장되었습니다!';
    } else if (modalType === AdminModalType.USER_EDIT_FAIL) {
      return '회원정보변경에 실패했습니다.';
    } else if (modalType === AdminModalType.USER_DELETE_CONFIRM) {
      return '회원정보를 삭제하시겠습니까?';
    } else if (modalType === AdminModalType.USER_DELETE_FAIL) {
      return '회원정보 삭제에 실패했습니다.';
    } else {
      return '';
    }
  };

  const createModalContent = () => {
    if (modalType === AdminModalType.USER_EDIT_CANCEL) {
      return '이 작업은 되돌릴 수 없습니다.';
    } else if (modalType === AdminModalType.USER_UPSERT_SUCCESS) {
      return '회원정보가 저장되었습니다.';
    } else if (modalType === AdminModalType.USER_EDIT_FAIL) {
      return '요청이 실패하였습니다. 다시 시도해주세요.';
    } else if (modalType === AdminModalType.USER_DELETE_CONFIRM) {
      return '회원정보는 복구할 수 없습니다.';
    } else if (modalType === AdminModalType.USER_DELETE_FAIL) {
      return '요청이 실패하였습니다. 다시 시도해주세요.';
    } else {
      return '';
    }
  };

  const createModalButtonText = () => {
    if (modalType === AdminModalType.USER_EDIT_CANCEL) {
      return '취소하기';
    } else if (modalType === AdminModalType.USER_DELETE_CONFIRM) {
      return '삭제하기';
    } else {
      return '확인';
    }
  };

  const createModalButtonVariant = () => {
    if (
      modalType === AdminModalType.USER_EDIT_CANCEL ||
      modalType === AdminModalType.USER_UPSERT_SUCCESS ||
      modalType === AdminModalType.USER_DELETE_CONFIRM
    ) {
      return 'contained';
    } else {
      return 'outlined';
    }
  };

  const createModalButtonCount = () => {
    if (modalType === AdminModalType.USER_EDIT_CANCEL || modalType === AdminModalType.USER_DELETE_CONFIRM) {
      return 2;
    } else {
      return 1;
    }
  };

  const createModalCancelButtonText = () => {
    if (modalType === AdminModalType.USER_EDIT_CANCEL) {
      return '돌아가기';
    } else {
      return '취소하기';
    }
  };

  // 접근 권한이 없으면 ForbiddenElement 표시
  if (!canAccessEdit) {
    return <ForbiddenElement />;
  }

  return (
    <>
      <AdminMenuTop />

      <div style={{ display: 'flex' }}>
        <AdminNavigation />

        <div
          ref={scrollContainerRef}
          className="hide-scrollbar"
          style={{
            width: '100%',
            height: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
            padding: '48px 240px 96px 240px',
            overflowY: 'auto'
          }}
        >
          <Text variant="h2" fontWeight="bold" marginBottom="40px">
            회원정보변경
          </Text>

          {response && (
            <div>
              <div style={{ width: 440, display: 'flex', flexDirection: 'column', gap: '24px', paddingBottom: '32px' }}>
                <TextInput
                  ref={nameRef}
                  label="이름"
                  placeholder="김레블"
                  helperText={errors.name || ''}
                  isError={!!errors.name}
                  value={formData.name}
                  onChange={(e) => handleInputChange('name', e.target.value)}
                />

                <TextInput
                  disabled={true}
                  label="이메일"
                  helperText="이메일은 변경할 수 없습니다."
                  value={response?.data.email}
                  autoComplete="off"
                />

                <div ref={contactRef}>
                  <Text variant="subtitle" fontWeight="bold" marginBottom="8px">
                    연락처
                  </Text>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '8px',
                      marginBottom: '4px'
                    }}
                  >
                    <div style={{ width: '125px' }}>
                      <Select
                        value={formData.countryCode}
                        onChange={(e) => handleInputChange('countryCode', e.target.value)}
                      >
                        {Object.entries(ContactCountryCodeEnum).map(([label, value]) => (
                          <MenuItem key={value} value={value}>
                            {label}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                    <div style={{ width: '327px' }}>
                      <TextInput
                        placeholder="01012345678"
                        isError={!!errors.contact}
                        value={formData.contact}
                        onChange={(e) => handleContactChange(e.target.value)}
                      />
                    </div>
                  </div>
                  <Text variant="body2" color={errors.contact ? colorSet.errorMain : colorSet.gray400} marginTop="4px">
                    {errors.contact || '국가 코드를 포함한 개인 핸드폰번호 혹은 집 전화번호를 입력해주세요.'}
                  </Text>
                </div>

                <div>
                  <Text variant="subtitle" fontWeight="bold" marginBottom="8px">
                    허용 IP
                  </Text>
                  {formData.userIps.map((ip, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '8px',
                        marginBottom: '8px',
                        alignItems: 'flex-start'
                      }}
                    >
                      <div style={{ width: '125px' }}>
                        <TextInput
                          ref={(el) => (ipRefs.current[index * 2] = el)}
                          placeholder="IP명"
                          value={ip.nickname}
                          onChange={(e) => handleIpChange(index, 'nickname', e.target.value)}
                          helperText={errors.userIps[index]?.nickname || ''}
                          isError={!!errors.userIps[index]?.nickname}
                        />
                      </div>
                      <div style={{ width: '327px', display: 'flex', flexDirection: 'row' }}>
                        <div style={{ width: formData.userIps.length > 1 ? '243px' : '327px' }}>
                          <TextInput
                            ref={(el) => (ipRefs.current[index * 2 + 1] = el)}
                            placeholder="IP 입력"
                            value={ip.ip}
                            onChange={(e) => handleIpChange(index, 'ip', e.target.value)}
                            helperText={errors.userIps[index]?.ip || ''}
                            isError={!!errors.userIps[index]?.ip}
                            sx={{
                              '.MuiOutlinedInput-root': {
                                ':hover': {
                                  border: `1px solid ${colorSet.primaryMain}`
                                },
                                '&.Mui-focused': {
                                  border: `1px solid ${colorSet.gray600}`
                                },
                                '&.Mui-error': {
                                  border: `1px solid ${colorSet.errorMain}`
                                },
                                '&.Mui-disabled': {
                                  border: `1px solid ${colorSet.gray300}`,
                                  backgroundColor: colorSet.gray200,
                                  color: colorSet.gray400
                                },
                                borderTopRightRadius: formData.userIps.length > 1 ? 0 : '4px',
                                borderBottomRightRadius: formData.userIps.length > 1 ? 0 : '4px',
                                borderRight: formData.userIps.length > 1 ? 'none' : `1px solid ${colorSet.gray300}`
                              }
                            }}
                          />
                        </div>
                        {formData.userIps.length > 1 && (
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => handleRemoveIp(index)}
                            sx={{
                              width: 84,
                              height: 44,
                              borderTopRightRadius: '5px',
                              borderBottomRightRadius: '5px'
                            }}
                          >
                            <TrashCanErrorIcon style={{ width: 20, height: 20 }} />
                          </Button>
                        )}
                      </div>
                    </div>
                  ))}
                  <Button
                    variant="outlined"
                    color="primary"
                    sx={{ width: 137, height: 44 }}
                    onClick={handleAddIp}
                    disabled={!isAddIpButtonEnabled}
                  >
                    {isAddIpButtonEnabled ? (
                      <PlusPrimaryIcon style={{ width: 20, height: 20 }} />
                    ) : (
                      <PlusGray300Icon style={{ width: 20, height: 20 }} />
                    )}

                    <Text variant="body1" fontWeight="bold" color={isAddIpButtonEnabled ? 'primary' : 'gray400'}>
                      IP 추가
                    </Text>
                  </Button>
                </div>

                <Select
                  label="권한"
                  disabled={formData.role === UserRoleEnum['루트 관리자']}
                  value={formData.role}
                  onChange={(e) => handleInputChange('role', e.target.value)}
                >
                  {getRoleOptions(formData.role).map((item, index) => (
                    <MenuItem value={item.value} key={index}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
                {loginUserRole === UserRoleEnum['루트 관리자'] && formData.role === UserRoleEnum['루트 관리자'] && (
                  <Text variant="body2" color={colorSet.gray400} marginTop="-20px">
                    루트 관리자는 권한 변경이 불가능합니다.
                  </Text>
                )}
              </div>

              <div style={{ borderBottom: `1px solid ${colorSet.gray300}` }} />

              <div
                style={{
                  width: 440,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '24px',
                  paddingTop: '32px',
                  marginBottom: '40px'
                }}
              >
                <div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: '4px',
                      marginBottom: '8px'
                    }}
                  >
                    <Text variant="h3" fontWeight="bold">
                      비밀번호 재설정
                    </Text>
                    <Text variant="body1" color={colorSet.gray400}>
                      (Optional)
                    </Text>
                  </div>
                  <Text variant="body1">변경할 때만 입력해 주세요. 비워두면 기존 비밀번호가 유지됩니다.</Text>
                </div>

                <TextInput
                  ref={passwordRef}
                  label="새 비밀번호"
                  placeholder="Password"
                  helperText={errors.password || '4~20자로 입력해 주세요.'}
                  isError={!!errors.password}
                  type="password"
                  value={formData.password}
                  onChange={(e) => handleInputChange('password', e.target.value)}
                  autoComplete="new-password"
                />
                <TextInput
                  ref={passwordConfirmRef}
                  label="새 비밀번호 확인"
                  placeholder="Password"
                  helperText={errors.passwordConfirm || ''}
                  isError={!!errors.passwordConfirm}
                  type="password"
                  value={passwordConfirm}
                  onChange={(e) => handlePasswordConfirmChange(e.target.value)}
                  autoComplete="new-password"
                />
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '12px' }}>
                <div>
                  {formData.role !== UserRoleEnum['루트 관리자'] && (
                    <Button
                      disabled={isPatchUserPending || isDeleteUserPending}
                      onClick={handleDeleteButtonClick}
                      variant="contained"
                      color="error"
                    >
                      계정 삭제
                    </Button>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
                  <Button
                    disabled={isPatchUserPending || isDeleteUserPending}
                    onClick={handleCancel}
                    variant="contained"
                    color="secondary"
                  >
                    취소
                  </Button>
                  <Button
                    disabled={isPatchUserPending || isDeleteUserPending}
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                  >
                    저장
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <GuideModal
        isVisible={isModalVisible}
        onClick={handleModalConfirmClick}
        onClose={() => {
          if (modalType === AdminModalType.USER_UPSERT_SUCCESS) {
            handleModalConfirmClick();
          } else {
            handleModalClose();
          }
        }}
        imgSrc={modalType === AdminModalType.USER_UPSERT_SUCCESS ? check_circle_primary : undefined}
        title={createModalTitle()}
        content={createModalContent()}
        buttonText={createModalButtonText()}
        buttonVariant={createModalButtonVariant()}
        buttonCount={createModalButtonCount()}
        cancelButtonText={createModalCancelButtonText()}
      />
    </>
  );
};

export default UserEditPage;
